import { render, staticRenderFns } from "./CourseName.vue?vue&type=template&id=78d5e16e&scoped=true&"
import script from "./CourseName.vue?vue&type=script&lang=js&"
export * from "./CourseName.vue?vue&type=script&lang=js&"
import style0 from "./CourseName.vue?vue&type=style&index=0&id=78d5e16e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5e16e",
  null
  
)

export default component.exports